import type { AppState } from '../types';
import type { DefaultPrinters } from './types';
import type { PrintPreview } from '~/main/printer/types';

export const getDefaultPrinters = (state: AppState): DefaultPrinters => state.printers.default;

export const getPrintersPreview = (state: AppState): PrintPreview | undefined =>
  state.printers.preview;
